/* Datas e números em pt-BR. Aceita texto ISO (como vem da API) ou Date. */
type DateIn = string | Date;
const toDate = (d: DateIn) => (typeof d === 'string' ? new Date(d) : d);

const dtTime = new Intl.DateTimeFormat('pt-BR', { hour: '2-digit', minute: '2-digit' });
const dtDay = new Intl.DateTimeFormat('pt-BR', { weekday: 'long', day: 'numeric', month: 'long' });
const dtShort = new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: 'short' });
const dtWeekday = new Intl.DateTimeFormat('pt-BR', { weekday: 'short' });
const nf = new Intl.NumberFormat('pt-BR');

export function sameDay(a: DateIn, b: DateIn) {
  const x = toDate(a), y = toDate(b);
  return x.getFullYear() === y.getFullYear() && x.getMonth() === y.getMonth() && x.getDate() === y.getDate();
}

export const fmt = {
  time: (d: DateIn) => dtTime.format(toDate(d)),
  day: (d: DateIn) => dtDay.format(toDate(d)),
  short: (d: DateIn) => dtShort.format(toDate(d)).replace('.', ''),
  weekday: (d: DateIn) => dtWeekday.format(toDate(d)).replace('.', ''),
  num: (n: number) => nf.format(n),
  /* "AAAA-MM-DD" sem conversão de fuso (um prazo é um dia, não um instante). */
  dateOnly(ymd: string) {
    const [y, m, d] = ymd.split('-').map(Number);
    return dtShort.format(new Date(y!, (m ?? 1) - 1, d ?? 1)).replace('.', '');
  },
  relative(d: DateIn, now = new Date()) {
    const diff = Math.round((now.getTime() - toDate(d).getTime()) / 60000);
    if (diff < 1) return 'agora';
    if (diff < 60) return `há ${diff} min`;
    const h = Math.round(diff / 60);
    if (h < 24) return `há ${h} h`;
    const days = Math.round(h / 24);
    return days === 1 ? 'ontem' : `há ${days} dias`;
  },
  smart(d: DateIn, now = new Date()) {
    const x = toDate(d);
    if (sameDay(x, now)) return dtTime.format(x);
    const y = new Date(now);
    y.setDate(now.getDate() - 1);
    if (sameDay(x, y)) return 'ontem';
    return dtShort.format(x).replace('.', '');
  },
  greeting(now = new Date()) {
    const h = now.getHours();
    if (h < 5) return 'Boa noite';
    if (h < 12) return 'Bom dia';
    if (h < 18) return 'Boa tarde';
    return 'Boa noite';
  }
};
